import * as React from "react"

import Details from "Catalog/Edit/shared/components/Details"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICategoryOrProduct, isCategory } from "shared/hubrise/models"

const Preview = ({ categoryOrProduct }: { categoryOrProduct: ICategoryOrProduct }): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { catalogNavigation } = useCatalogNavigation()

  return (
    <Details.TopbarButton
      onClick={() =>
        navigate(
          isCategory(categoryOrProduct)
            ? catalogNavigation.previewPath("category", categoryOrProduct.id)
            : catalogNavigation.previewPath("product", categoryOrProduct.id),
        )
      }
      code="visibility"
    />
  )
}

export default Preview
